<template>
  <path
    id="zmiana"
    d="M7.85691636,16.0294835 L10.6993301,13.1870697 L12.3193872,14.8071268 L6.66519983,20.4613142 L0.995,14.7911143 L2.6104821,13.1756322 L5.57227965,16.1374298 L5.57227965,3.52588235 L7.85691636,3.52588235 L7.85691636,16.0294835 Z M16.8711032,7.86257023 L13.9093056,10.8243678 L12.2938235,9.20888566 L17.9640233,3.53868582 L23.6182108,9.19287321 L21.9981537,10.8129303 L19.1557399,7.97051654 L19.1557399,20.4741176 L16.8711032,20.4741176 L16.8711032,7.86257023 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'ChangeIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
